import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2, Mail } from "lucide-react";
import api from "@/lib/api";
import { formatAuthError } from "@/lib/authErrors";
import { useSeo } from "@/lib/seo";

export default function ForgotPassword() {
    useSeo({ title: "Password dimenticata | VendiDirect", description: "Richiedi il link per impostare una nuova password.", noindex: true });
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const submit = async (event) => {
        event.preventDefault();
        setBusy(true); setError(""); setMessage("");
        try {
            const { data } = await api.post("/auth/forgot-password", { email });
            setMessage(data.detail);
        } catch (requestError) {
            setError(formatAuthError(requestError?.response?.data?.detail));
        } finally { setBusy(false); }
    };

    return (
        <main data-testid="forgot-password-page" className="login-luxury-page">
            <div className="login-luxury-panel">
                <div className="login-luxury-icon"><Mail size={25} /></div>
                <h1 data-testid="forgot-password-title" className="login-luxury-title text-center">Password dimenticata?</h1>
                <p className="login-luxury-subtitle text-center">Inserisci l’email del tuo account. Il link scade tra 30 minuti.</p>
                <form data-testid="forgot-password-form" onSubmit={submit} className="login-credentials-form">
                    <label className="login-field">Email
                        <input data-testid="forgot-password-email-input" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="login-input" placeholder="nome@email.it" />
                    </label>
                    {error && <div data-testid="forgot-password-error" className="login-alert login-alert-error">{error}</div>}
                    {message && <div data-testid="forgot-password-success" className="login-alert login-alert-success">{message}</div>}
                    <button data-testid="forgot-password-submit-button" type="submit" disabled={busy} className="login-submit-button">{busy ? <Loader2 className="animate-spin" size={17} /> : <Mail size={17} />} Invia link di reset</button>
                </form>
                <Link data-testid="forgot-password-back-link" to="/login" className="login-back-link"><ArrowLeft size={14} /> Torna ad Accedi</Link>
            </div>
        </main>
    );
}